/* =============================================================
 *  UBS TOOLS — kayis ve zincir merkez mesafesi hesaplayicilari
 *
 *  MATEMATIK (Recalc, recalc.io — Justin Telvay, MIT lisansi ile
 *  ayni bagintilar):
 *
 *    Bolum capi        Di = Ni * p / PI
 *    Kayis adim boyu   L  = Td * p
 *    Ara buyukluk      K  = L - p * (N1 + N2) / 2
 *    Merkez mesafesi   C  = [ K + sqrt(K^2 - 2 * (D2 - D1)^2) ] / 4
 *
 *    Ters yon (hedef C -> gereken boy):
 *                      L  = 2C + PI*(D1+D2)/2 + (D2-D1)^2 / (4C)
 *
 *  Zincir ayni bagintilari kullanir, sonuc TAM BAKLAYA yuvarlanir;
 *  yarim bakla kapaliysa cift sayiya yuvarlanir (tek baklali zincir
 *  yarim bakla olmadan kapanmaz).
 *
 *  DIKKAT: K^2 - 2*(D2-D1)^2 negatifse kayis o kasnak ciftine
 *  FIZIKSEL OLARAK sarilamaz (cok kisa). Bu durumda hesap yerine
 *  uyari gosteriliyor - sessizce NaN basmak yanlis olurdu.
 * ============================================================= */
/* Birden fazla ornek olabilir: UBS Tools sayfasinda sekmeli tam surum,
 * urun sayfasinda yalnizca ilgili hesaplayici. Her kok kendi durumunu,
 * kendi boy listesini ve kendi cevirilerini tasir. */
(function () {
  'use strict';

  var MM_IN = 25.4;

  function kur(kok) {
  if (kok.__ubsAracKurulu) return;
  kok.__ubsAracKurulu = true;

  function $(s, k) { return (k || kok).querySelector(s); }
  function $$(s, k) { return Array.prototype.slice.call((k || kok).querySelectorAll(s)); }

  var boylar = {};
  var boylarEl = $('[data-arac-boylar]');
  if (boylarEl) {
    try { boylar = JSON.parse(boylarEl.textContent); } catch (e) { boylar = {}; }
  }

  function sayi(deger) {
    var n = parseFloat(deger);
    return isFinite(n) ? n : NaN;
  }

  function bicim(n, basamak) {
    if (!isFinite(n)) return '—';
    return n.toLocaleString('tr-TR', {
      minimumFractionDigits: basamak, maximumFractionDigits: basamak
    });
  }

  /* --- Cekirdek hesap --------------------------------------------------- */

  // Kayis/zincir boyundan merkez mesafesi
  function ctcHesapla(p, n1, n2, td) {
    var d1 = n1 * p / Math.PI;
    var d2 = n2 * p / Math.PI;
    var k  = td * p - p * (n1 + n2) / 2;
    var kok2 = k * k - 2 * Math.pow(d2 - d1, 2);
    if (kok2 < 0) return { hata: 'kisa', d1: d1, d2: d2 };
    var c = (k + Math.sqrt(kok2)) / 4;
    if (!isFinite(c) || c <= 0) return { hata: 'kisa', d1: d1, d2: d2 };
    return { c: c, d1: d1, d2: d2, bosluk: c - (d1 + d2) / 2 };
  }

  // Merkez mesafesinden gereken dis/bakla sayisi (tam sayi degil, ham)
  function boyHesapla(p, n1, n2, c) {
    var d1 = n1 * p / Math.PI;
    var d2 = n2 * p / Math.PI;
    var l  = 2 * c + Math.PI * (d1 + d2) / 2 + Math.pow(d2 - d1, 2) / (4 * c);
    return { td: l / p, d1: d1, d2: d2 };
  }

  function enYakin(liste, hedef) {
    var en = null, fark = Infinity;
    for (var i = 0; i < liste.length; i++) {
      var v = parseInt(liste[i], 10);
      if (!isFinite(v)) continue;
      var f = Math.abs(v - hedef);
      if (f < fark) { fark = f; en = v; }
    }
    return en;
  }

  var ceviriler = null;
  function ceviriAl(anahtar) {
    if (ceviriler === null) {
      var el = $('[data-arac-ceviri]');
      try { ceviriler = el ? JSON.parse(el.textContent) : {}; } catch (e) { ceviriler = {}; }
    }
    return ceviriler[anahtar] || anahtar;
  }

  /* --- Durum ------------------------------------------------------------ */

  var durum = {
    kayis:  { adim: 2,    kip: 'belt', birim: 'mm' },
    zincir: { adim: 6.35, kip: 'belt', birim: 'mm' }
  };

  function segmentBagla(ad, alan, cevir) {
    var grup = $('[data-segment="' + ad + '"]');
    if (!grup) return;
    $$('.segment__btn', grup).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.segment__btn', grup).forEach(function (o) {
          o.classList.toggle('is-active', o === b);
          o.setAttribute('aria-pressed', String(o === b));
        });
        var v = b.getAttribute('data-deger');
        var hedefAd = ad.split('-')[0];
        durum[hedefAd][alan] = cevir ? cevir(v) : v;
        if (alan === 'kip') kipGuncelle(hedefAd);
        if (alan === 'birim') birimGuncelle(hedefAd);
        hesapla(hedefAd);
      });
    });
  }

  function kipGuncelle(hangi) {
    var panel = $('[data-arac-panel="' + hangi + '"]');
    if (!panel) return;
    $$('[data-goster]', panel).forEach(function (el) {
      el.hidden = el.getAttribute('data-goster') !== durum[hangi].kip;
    });
  }

  function birimGuncelle(hangi) {
    var et = $('[data-birim-etiket="' + hangi + '"]');
    if (et) et.textContent = durum[hangi].birim;
  }

  /* --- Ciktilar --------------------------------------------------------- */

  function satir(etiket, deger) {
    return '<div class="arac__satir"><span>' + etiket + '</span><b>' + deger + '</b></div>';
  }

  function ciz(hangi, html) {
    var el = $('[data-sonuc="' + hangi + '"]');
    if (el) el.innerHTML = html;
  }

  function uzunluk(mm, birim) {
    return birim === 'in'
      ? bicim(mm / MM_IN, 3) + ' in'
      : bicim(mm, 2) + ' mm';
  }

  function hesapla(hangi) {
    // Urun sayfasinda yalnizca bir panel basiliyor; olmayan paneli hesaplama
    if (!$('[data-arac-panel="' + hangi + '"]')) return;
    var d = durum[hangi];
    var p = d.adim;
    var n1 = sayi($('[data-giris="' + hangi + '-n1"]').value);
    var n2 = sayi($('[data-giris="' + hangi + '-n2"]').value);

    if (!isFinite(n1) || !isFinite(n2) || n1 < 6 || n2 < 6) {
      ciz(hangi, '<p class="arac__uyari">' + ceviriAl('gecersiz') + '</p>');
      return;
    }

    var zincirMi = hangi === 'zincir';

    if (d.kip === 'belt') {
      var td = sayi($('[data-giris="' + hangi + '-td"]').value);
      if (!isFinite(td) || td < 10) {
        ciz(hangi, '<p class="arac__uyari">' + ceviriAl('gecersiz') + '</p>');
        return;
      }
      var r = ctcHesapla(p, n1, n2, td);
      if (r.hata) {
        ciz(hangi, '<p class="arac__uyari">' + ceviriAl('kisa') + '</p>');
        return;
      }
      ciz(hangi,
        '<div class="arac__buyuk"><span>' + ceviriAl('ctc') + '</span><strong>' +
          uzunluk(r.c, d.birim) + '</strong></div>' +
        satir(ceviriAl('ctc_diger'), uzunluk(r.c, d.birim === 'mm' ? 'in' : 'mm')) +
        satir(ceviriAl(zincirMi ? 'disli1_cap' : 'kasnak1_cap'), uzunluk(r.d1, d.birim)) +
        satir(ceviriAl(zincirMi ? 'disli2_cap' : 'kasnak2_cap'), uzunluk(r.d2, d.birim)) +
        satir(ceviriAl('bosluk'), uzunluk(r.bosluk, d.birim))
      );
      return;
    }

    // Hedef CTC -> gereken boy
    var hedefHam = sayi($('[data-giris="' + hangi + '-hedef"]').value);
    if (!isFinite(hedefHam) || hedefHam <= 0) {
      ciz(hangi, '<p class="arac__uyari">' + ceviriAl('gecersiz') + '</p>');
      return;
    }
    var hedefMm = d.birim === 'in' ? hedefHam * MM_IN : hedefHam;
    var b = boyHesapla(p, n1, n2, hedefMm);

    var secilen, notMetni = '';
    if (zincirMi) {
      var yarim = $('[data-giris="zincir-yarim"]').checked;
      secilen = Math.ceil(b.td);
      if (!yarim && secilen % 2 !== 0) secilen += 1;
      notMetni = yarim ? ceviriAl('yarim_acik') : ceviriAl('cift_bakla');
    } else {
      var liste = (boylar.kayis && boylar.kayis[String(p)]) || [];
      liste = liste.filter(function (x) { return String(x).trim() !== ''; });
      if (liste.length) {
        secilen = enYakin(liste, b.td);
        notMetni = ceviriAl('stok_boy');
      } else {
        secilen = Math.round(b.td);
      }
    }

    var g = ctcHesapla(p, n1, n2, secilen);
    ciz(hangi,
      '<div class="arac__buyuk"><span>' + ceviriAl(zincirMi ? 'gereken_bakla' : 'gereken_kayis') +
        '</span><strong>' + secilen + (zincirMi ? '' : ' T') + '</strong></div>' +
      satir(ceviriAl('ham_hesap'), bicim(b.td, 2) + (zincirMi ? '' : ' T')) +
      (g.hata ? '' : satir(ceviriAl('gercek_ctc'), uzunluk(g.c, d.birim))) +
      (g.hata ? '' : satir(ceviriAl('hedeften_fark'), uzunluk(g.c - hedefMm, d.birim))) +
      (notMetni ? '<p class="arac__not">' + notMetni + '</p>' : '')
    );
  }

  /* --- Baglanti --------------------------------------------------------- */

  $$('[data-arac-tab]').forEach(function (t) {
    t.addEventListener('click', function () {
      var ad = t.getAttribute('data-arac-tab');
      $$('[data-arac-tab]').forEach(function (o) {
        o.classList.toggle('is-active', o === t);
        o.setAttribute('aria-selected', String(o === t));
      });
      $$('[data-arac-panel]').forEach(function (p) {
        var esit = p.getAttribute('data-arac-panel') === ad;
        p.classList.toggle('is-active', esit);
        p.hidden = !esit;
      });
    });
  });

  segmentBagla('kayis-adim', 'adim', parseFloat);
  segmentBagla('kayis-kip', 'kip');
  segmentBagla('kayis-birim', 'birim');
  segmentBagla('zincir-adim', 'adim', parseFloat);
  segmentBagla('zincir-kip', 'kip');
  segmentBagla('zincir-birim', 'birim');

  $$('[data-giris]').forEach(function (el) {
    el.addEventListener('input', function () {
      hesapla(el.getAttribute('data-giris').split('-')[0]);
    });
    el.addEventListener('change', function () {
      hesapla(el.getAttribute('data-giris').split('-')[0]);
    });
  });

  hesapla('kayis');
  hesapla('zincir');
  }

  function baslat() {
    Array.prototype.slice.call(document.querySelectorAll('[data-arac]')).forEach(kur);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
